module.exports = __webpack_public_path__ + "static/media/5_evenement.826e627f.jpg";